import Route from "@rio-cloud/rio-uikit/Route";
import { IRouteSegment } from "../interfaces/IRouteSegment"
import { getRandomValueToForceRerender } from "../functions/getRandomValueToForceRerender";

export const CurrencySegments = ({ segments }: { segments: IRouteSegment[] }) => {
    const mapSegments = segments.map((segment) => {
      return (
        <Route
          key={getRandomValueToForceRerender()}
          positions={segment.points}
          isRouteAlternative={segment.alternative}
          hasArrows={true}
          arrowStyle={{
            color: "red",
          }}
          style={{
            color: "#000",
          }}    
        />
      );
    });
    return <>{mapSegments}</>;
  };